import React from 'react'
import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  base: {
    background: '#e9f5fe',
    borderRadius: '10px',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    margin: '0 8px',
  },
  logo: {
    width: '50px',
    minWidth: '50px',
  },
  body: {
    padding: '16px 0',
  },
}))

const Disclaimer = ({ logo, alt = 'Logo', description }) => {
  const classes = useStyles()
  return (
    <Box display="flex" flexDirection="row" className={classes.base}>
      <img src={logo} alt={alt} className={classes.logo} />
      <Divider orientation="vertical" flexItem className={classes.divider} />
      <Typography className={classes.body}>{description}</Typography>
    </Box>
  )
}

export default Disclaimer
